import { ChangeDetectionStrategy, Component, effect } from '@angular/core';
import { AbstractBasePanelComponent } from '../utils/abstract-base-panel.component';
import { SkeletonScreenComponent } from '../skeleton-screen/skeleton-screen.component';
import { InputPanelComponent } from '../components/input-panel/input-panel.component';
import { PanelComponent } from '../panel/panel.component';
import { CurrencyPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

interface PhonePackageDto {
  id: string;
  name: string;
  price: number;
  description: string;
}

@Component({
  selector: 'webmodule-order-panel-mobile',
  templateUrl: './panel-mobile.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PanelComponent, InputPanelComponent, SkeletonScreenComponent, CurrencyPipe, TranslatePipe],
  standalone: true,
})
export class PanelMobileComponent extends AbstractBasePanelComponent<PhonePackageDto> {
  protected readonly string = String;
  readonly mobileDataBundle: PhonePackageDto[] = [
    {
      id: 'DATA_NONE',
      name: 'Geen mobiel internet',
      price: 0,
      description: '',
    },
    {
      id: 'DATA_5GB',
      name: '5GB data bundel',
      price: 14,
      description: "Internet: Je kunt je GB's gebruiken in NL én EU\n Bellen: Onbeperkt in NL en EU\n SMS: Onbeperkt in NL en EU",
    },
    {
      id: 'DATA_10GB',
      name: '10GB data bundel',
      price: 16,
      description: "Internet: Je kunt je GB's gebruiken in NL én EU\n Bellen: Onbeperkt in NL en EU\n SMS: Onbeperkt in NL en EU",
    },
    {
      id: 'DATA_15GB',
      name: '15GB data bundel',
      price: 18,
      description: "Internet: Je kunt je GB's gebruiken in NL én EU\n Bellen: Onbeperkt in NL en EU\n SMS: Onbeperkt in NL en EU",
    },
    {
      id: 'DATA_20GB',
      name: '20GB data bundel',
      price: 20,
      description: "Internet: Je kunt je GB's gebruiken in NL én EU\n Bellen: Onbeperkt in NL en EU\n SMS: Onbeperkt in NL en EU",
    },
    {
      id: 'DATA_UNLIMITED',
      name: 'Unlimited data bundel',
      price: 30,
      description: "Internet: Je kunt je GB's gebruiken in NL én EU\n Bellen: Onbeperkt in NL en EU\n SMS: Onbeperkt in NL en EU",
    },
  ];

  constructor() {
    super();

    effect(() => {
      if (!this.select()) {
        this.select.set(this.mobileDataBundle[0] ?? null);
      }
    });
  }
}
